import * as types from "../actionTypes";

export const show = id => {
  return {
    type: types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_REQUEST,
    id: id
  };
};

export const showSuccess = data => {
  return {
    type: types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const showFailure = error => {
  return {
    type: types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_FAILURE,
    error: error
  };
};

export const showByAccountTitles = imprestId => {
  return {
    type: types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_REQUEST,
    imprestId: imprestId
  };
};

export const showByAccountTitlesSuccess = data => {
  return {
    type: types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_SUCCESS,
    payLoad: data
  };
};
export const showByAccountTitlesFailure = error => {
  return {
    type: types.PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_FAILURE,
    error: error
  };
};
